package one.healthium.notifications.di

import one.healthium.notifications.scheduler.NotificationScheduler
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

internal actual fun notificationsPlatformModule() = module {
    singleOf(::NotificationScheduler)
}